module.exports = __webpack_public_path__ + "static/img/stay-option-icon-campfire.3d90ef93.svg";